<template>
<div>
  <div
    class="form-row"
    v-if="loaded"
  >
    <div
      class="col form-group input-group"
      v-if="!readonly"
    >
      <div
        class="input-group-prepend"
      >
        <div
          class="input-group-text"
        >
          <ItpIcon
            icon="mdi:payment-clock"
          >
          </ItpIcon>
        </div>
      </div>
      <ItpFormSelect
        name="selectedRuleID"
        v-model="selectedRuleID"
        :options="rules"
        valueField="id"
        textField="rule.description"
        :placeholder="'Select predefined rule to add.'|pgettext('DueDateRule')"
      >
      </ItpFormSelect>
      <div
        class="input-group-append"
      >
        <ItpButton
          variant="light"
          icon="fa-plus"
          :tooltip="'Add rule configuration'|pgettext('DueDateRule')"
          :disabled="!selectedRuleID"
          @click="evh_4207795475682514_click($event, {})"
        >
        </ItpButton>
      </div>
    </div>
  </div>
  <div
    class="form-row"
    v-if="loaded"
  >
    <div
      class="form-group col-md-8"
    >
      <ItpFormSelect
        name="anchor"
        v-model="item.anchor"
        :options="anchorOptions"
        valueField="value"
        textField="name"
        required
        :readonly="readonly"
      >
      </ItpFormSelect>
    </div>
    <div
      class="form-group col-md-4"
    >
      <div
        class="input-group"
      >
        <div
          class="input-group-prepend"
        >
          <div
            class="input-group-text"
          >
            <input
              type="checkbox"
              v-model="isOffsetDaysSet"
              :readonly="readonly"
              @change="evh_6217772979034815_change($event, {})"
            >
            </input>
          </div>
        </div>
        <ItpFormInput
          type="number"
          name="offset_days"
          v-model="item.offset_days"
          :disabled="!isOffsetDaysSet"
          :readonly="readonly"
          ref="offsetDays"
        >
        </ItpFormInput>
        <DIV
          class="input-group-append"
        >
          <span
            class="input-group-text"
          >
            {{ 'day'|pgettext('InputGroupAddon') }}
          </span>
        </DIV>
      </div>
    </div>
  </div>
  <div
    class="form-row"
    v-if="loaded"
  >
    <div
      class="col"
    >
      <ItpFormInput
        name="description"
        v-model="item.description"
        :placeholder="'Rule description'|pgettext('DueDateRule')"
        :readonly="readonly"
        v-if="loaded"
      >
      </ItpFormInput>
    </div>
  </div>
</div>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class DueDateRuleFields extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  addRule(...args: any[]) {
    const [id] = args;
    const obj = _.find(this.rules, { id });
    if (obj) {
      _.extend(this.item, obj.rule);
      this.setData('selectedRuleID', null);
    }
  }

  onCheckChanged(...args: any[]) {
    if (this.isOffsetDaysSet) {
      this.setData('item.offset_days', 0);
    }
    else {
      this.setData('item.offset_days', null);
    }
  }

  @Prop({
    type: Object,
  })
  value!: object;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  item!: any;

  async $$load_item() {
    return this.value
  }

  labelAlign!: any;
  rule_type!: any;
  rules!: any;

  async $$load_rules() {
    return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'billing-rule' } })
      .then(items => _.chain(items).filter({ rule_type: this.rule_type }).value())
  }

  selectedRuleID!: any;
  isOffsetDaysSet!: any;

  async $$load_isOffsetDaysSet() {
    return this.item.offset_days != null
  }

  metadata!: any;

  async $$load_metadata() {
    return this.$app.repo.get('ui_metadata')
  }

  anchorOptions!: any;

  async $$load_anchorOptions() {
    return this.metadata.billing_date_rule_anchor_options
  }

  ux!: any;
  dataMembers = ['item', 'labelAlign', 'rule_type', 'rules', 'selectedRuleID', 'isOffsetDaysSet', 'metadata', 'anchorOptions', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        labelAlign: "right",
        rule_type: "due_date",
        rules: null,
        selectedRuleID: null,
        isOffsetDaysSet: null,
        metadata: null,
        anchorOptions: null,
        ux: null,
      },
    }
  }

  async act_4207795475682514_script_6642_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_4207795475682514_script_6642, alias=undefined
    this.addRule(this.selectedRuleID)
  }

  async act_4207795475682514_script_6642_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_4207795475682514_script_6642, alias=undefined
    return {
      value: () => this.act_4207795475682514_script_6642_getActionArgs_value($event),
    }
  }

  async evh_4207795475682514_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4207795475682514_click.executeFromDOM(this, event, scope);
  }

  async act_6217772979034815_script_6644_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_6217772979034815_script_6644, alias=undefined
    this.$nextTick(() => this.onCheckChanged(this.isOffsetDaysSet))
  }

  async act_6217772979034815_script_6644_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_6217772979034815_script_6644, alias=undefined
    return {
      value: () => this.act_6217772979034815_script_6644_getActionArgs_value($event),
    }
  }

  async evh_6217772979034815_change(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6217772979034815_change.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_4207795475682514_script_6642: actions.ScriptAction;
    evh_4207795475682514_click_6641: actions.EventHandlerImpl;
    evh_4207795475682514_click: actions.EventHandlerGroup;
    act_6217772979034815_script_6644: actions.ScriptAction;
    evh_6217772979034815_change_6643: actions.EventHandlerImpl;
    evh_6217772979034815_change: actions.EventHandlerGroup;
  }

  getActions() {
    const act_4207795475682514_script_6642 = new actions.ScriptAction(
      {
        actionArgs: this.act_4207795475682514_script_6642_getActionArgs,
        events: [],
      }
    );
    const evh_4207795475682514_click_6641 = new actions.EventHandlerImpl(
      {
        action: act_4207795475682514_script_6642,
        event: "click",
        displayName: "script",
      }
    );
    const evh_4207795475682514_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4207795475682514_click_6641],
      }
    );
    const act_6217772979034815_script_6644 = new actions.ScriptAction(
      {
        actionArgs: this.act_6217772979034815_script_6644_getActionArgs,
        events: [],
      }
    );
    const evh_6217772979034815_change_6643 = new actions.EventHandlerImpl(
      {
        action: act_6217772979034815_script_6644,
        event: "change",
        displayName: "script",
      }
    );
    const evh_6217772979034815_change = new actions.EventHandlerGroup(
      {
        handlers: [evh_6217772979034815_change_6643],
      }
    );
    return {
      act_4207795475682514_script_6642,
      evh_4207795475682514_click_6641,
      evh_4207795475682514_click,
      act_6217772979034815_script_6644,
      evh_6217772979034815_change_6643,
      evh_6217772979034815_change,
    }
  }
}

Vue.component("DueDateRuleFields", DueDateRuleFields);

</script>